// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3xeQP","container":"styles_container__1oY1u"};